export const emptyDate = '0001-01-01T00:00:00'
//Determine if a date is empty
export function isEmptyDate(date)
{
	return date == '' || !date || date == emptyDate || date.toLowerCase() == 'undefined' || date == undefined;
}